import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';

const ListDatabaseTablePage = loadable(() => import('./ListDatabaseTablePage'), {
  fallback: <Loader />
});
const AddDatabaseTablePage = loadable(() => import('./AddDatabaseTablePage'), {
  fallback: <Loader />
});
const EditDatabaseTablePage = loadable(() => import('./EditDatabaseTablePage'), {
  fallback: <Loader />
});
const DatabaseTableRoute = ({ t, setTabLoading, alert }) => {
  return [
    <Route
      key="database_table_list"
      exact
      path="/view/:projectId/database/:databaseId/tables"
      element={<ListDatabaseTablePage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />,
    <Route
      key="database_table_add"
      exact
      path="/view/:projectId/database/:databaseId/tables/add"
      element={<AddDatabaseTablePage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />,
    <Route
      key="database_table_edit"
      exact
      path="/view/:projectId/database/:databaseId/tables/:id/edit"
      element={<EditDatabaseTablePage t={t} setTabLoading={setTabLoading} alert={alert} />}
    />
  ];
};
DatabaseTableRoute.propTypes = {
  t: PropTypes.func
};
export default DatabaseTableRoute;
